// Guarda en memoria el JWT emitido por la API en /login. No se persiste en
// localStorage a propósito: el login se vuelve a correr en cada carga de
// página vía onAuthStateChanged de Firebase, lo cual re-emite un token fresco.
let token = null;

export function setApiToken(nuevoToken) {
  token = nuevoToken || null;
}

export function getApiToken() {
  return token;
}
